import SerendipityShuffle from './SerendipityShuffle'

const Explore = ({ isDevUser }: { isDevUser: boolean }) => {
  return <SerendipityShuffle isDevUser={isDevUser} />
}

export default Explore
